@if (show) {
	<schir-int-client-button-round fontelloIcon="korrespondenz"
                               data-test-id="open-korrespondenz-button" (click)="openKorrespondenz.emit()"
                                   popup="dialog" [toolTip]="tooltip" cssClass="focus-inwards-dark schir-midi-button"/>
}
